import minutesToMilliseconds from 'date-fns/minutesToMilliseconds';

import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { FetchProgramPlaybackContextArgs, fetchProgramPlaybackContext } from './queryFunctions';

export function fetchProgramPlaybackContextQuery({
  adapterCodec,
  adapterDrm,
  adapterQuality,
  assetId,
  contextType,
  streamerType,
}: FetchProgramPlaybackContextArgs) {
  return queryClient.fetchQuery({
    queryKey: queryKeys.playbackContext(adapterCodec, adapterDrm, adapterQuality, assetId, streamerType),
    queryFn: () =>
      fetchProgramPlaybackContext({
        adapterCodec,
        adapterDrm,
        adapterQuality,
        assetId,
        contextType,
        streamerType,
      }),
    staleTime: minutesToMilliseconds(10),
  });
}
